import React from 'react';
import styled from 'styled-components/macro';
import {
	useEleccion
} from '../contexts/eleccionContext';
import FooterLayout from '../components/Footer/Footer';
import FilaBarPartido from '../components/FilaBarPartido';
import useWindowWidth from '../hooks/useWindowWidth';


const ResultadosVotosPartidosBar = () => {
	const election = useEleccion();
	const windowWidth = useWindowWidth();
	const barHorizontal = windowWidth.width < 1366;
	return (
		<div>
			<ContentContainer horizontal={barHorizontal}>
				{
					election.selectedCamara.partotabla.map((partido, index) => {
						return (
							<FilaBarPartido key={index} partido={partido.act} horizontal={barHorizontal} />
						)
					})
				}
			</ContentContainer>
			<FooterContainer horizontal={barHorizontal}>
				<FooterLayout />
			</FooterContainer>
		</div>
	);
};

const ContentContainer = styled.div`
	display: flex;
	flex-direction: ${({ horizontal }) => (horizontal ? 'column' : 'row')};
	// min-height: 65vh;
	justify-content: space-between;
	padding: 1% 3%;
	gap: 10px;
`;

const FooterContainer = styled.div`
	padding: ${({ horizontal }) => (horizontal ? '5%' : '2%')};

`;
export default ResultadosVotosPartidosBar;
